module.exports = {
  "country": "AT",
  "artist": "JJ ",
  "song": "Wasted Love",
  "year": "2025",
  "place": "1",
  "spotify": "321yySUTzRXUbzkRTeTzDB"
};